import $ from 'jquery';
import ampOpenPreferences from './amp-open-preferences';
import ampNewsletter from './amp-newsletter';
import ampCookie from './amp-cookie';
import smartBanner from 'modules/smart-banner';
import emailSignUpHandler from 'modules/email-sign-up';
import './fixed-corner';

function emailSignUp() {
  $('#email_signup_form').on('submit', emailSignUpHandler.eventHandler);
  $('#email-signup-target').on('click', emailSignUpHandler.eventHandler);
}

function initModalEventListeners() {
  $('.js-view-country-preferences').click(function(e) {
    e.preventDefault();
    var url = $(this).data("ajaxUrl");
    $.modal({
      url: url,
      type: 'full',
      triggerOpen: true,
      returnFocus: '.js-view-country-preferences',
    });
  });
}

// function executeGoogleRemarketing() {
//   googleRemarketing();
// }

// function executeCriteo() {
//   criteo.init('m');
// }

// function executePageTracking() {
//   return pageTracking();
// }

$(document).ready(function() {
  // Don't show smart banner on mobile
  if ($('.co_rev_logo').length === 0 && $('.checkout-header__nav-container').length === 0) {
    smartBanner({
      title: 'REVOLVEClothing',
      author: 'Eminent, Inc.',
      appendToSelector : '#home',
      icon : '//is4.revolveassets.com/r/i/logo-mobile.png'
    });
  }
  emailSignUp();
  initModalEventListeners();
  ampOpenPreferences();
  ampNewsletter();
  ampCookie();
  // executeGoogleRemarketing();
  // executeCriteo();
  // executePageTracking();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/index.js